import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const PickupDelivery: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <g clipPath="url(#clip0_1634_232)">
        <path
          d="M19.0275 12.915L18.93 21.765L8.24998 23.79L0.224976 19.5975L0.412476 11.5425L11.355 10.17L19.0275 12.915Z"
          fill="#FCC905"
        />
        <path
          d="M11.355 10.17L19.0275 12.915L8.43748 15.1725L0.412476 11.5425L11.355 10.17Z"
          fill="#FCC905"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.05066 12.0322C1.10332 11.9083 1.24645 11.8505 1.37034 11.9032L8.53284 14.9482C8.62389 14.9869 8.68251 15.0768 8.68121 15.1757L8.5762 23.1632C8.57443 23.2978 8.46388 23.4055 8.32927 23.4038C8.19466 23.402 8.08698 23.2914 8.08875 23.1568L8.1916 15.3329L1.17961 12.3519C1.05572 12.2992 0.997987 12.1561 1.05066 12.0322Z"
          fill="black"
        />
        <path
          d="M15.8625 11.7675L5.37748 13.6275C5.14498 13.7025 4.98748 13.9125 4.97248 14.1525L4.84498 16.4025L3.28498 15.75L3.43498 13.29C3.44248 13.0425 3.60748 12.825 3.84748 12.75L13.935 11.1075L15.8625 11.76V11.7675Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2089 13.1967C18.2356 13.3287 18.1502 13.4573 18.0183 13.4839L8.48578 15.4114C8.35384 15.4381 8.22524 15.3528 8.19856 15.2208C8.17188 15.0889 8.25722 14.9603 8.38917 14.9336L17.9217 13.0061C18.0536 12.9794 18.1822 13.0648 18.2089 13.1967Z"
          fill="black"
        />
        <path
          d="M17.97 0.217529C14.685 0.217529 12.015 2.88003 12.015 6.17253C12.27 11.535 17.97 16.7925 17.97 16.7925C17.97 16.7925 23.7525 11.535 23.925 6.17253C23.925 2.88753 21.2625 0.217529 17.97 0.217529Z"
          fill="#FF452D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0034 5.92905C12.1379 5.92266 12.2521 6.02648 12.2585 6.16095C12.3825 8.76875 13.8357 11.3754 15.2846 13.3492C16.006 14.3321 16.72 15.1494 17.2535 15.7209C17.5202 16.0066 17.7415 16.2305 17.8957 16.3826C17.923 16.4096 17.9482 16.4342 17.9712 16.4566C18.0506 16.3804 18.1564 16.2772 18.2836 16.1491C18.5832 15.8478 19.0011 15.4095 19.473 14.8632C19.561 14.7613 19.715 14.7501 19.8168 14.8381C19.9187 14.9261 19.9299 15.08 19.8419 15.1819C19.3614 15.7381 18.9355 16.1848 18.6294 16.4928C18.4763 16.6468 18.3531 16.7663 18.2678 16.8475C18.2252 16.8881 18.192 16.9192 18.1693 16.9402L18.1433 16.9643L18.1365 16.9706L18.1346 16.9723L18.1339 16.9729L17.97 16.7925C17.8047 16.9717 17.8046 16.9716 17.8046 16.9716L17.8033 16.9704L17.7999 16.9672L17.787 16.9552C17.7757 16.9446 17.7592 16.9291 17.7378 16.9087C17.695 16.8679 17.6326 16.8078 17.5534 16.7297C17.3949 16.5734 17.1689 16.3446 16.8972 16.0536C16.354 15.4718 15.627 14.6396 14.8916 13.6377C13.4267 11.6421 11.9025 8.93881 11.7715 6.18411C11.7651 6.04964 11.8689 5.93545 12.0034 5.92905ZM17.97 16.7925L17.8046 16.9716C17.8974 17.0572 18.0405 17.0578 18.1339 16.9729L17.97 16.7925Z"
          fill="black"
        />
        <path
          d="M17.97 8.72253C19.1588 8.72253 20.1225 7.75882 20.1225 6.57003C20.1225 5.38124 19.1588 4.41753 17.97 4.41753C16.7812 4.41753 15.8175 5.38124 15.8175 6.57003C15.8175 7.75882 16.7812 8.72253 17.97 8.72253Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.97 4.66128C16.9158 4.66128 16.0612 5.51586 16.0612 6.57003C16.0612 7.6242 16.9158 8.47878 17.97 8.47878C19.0241 8.47878 19.8787 7.6242 19.8787 6.57003C19.8787 5.51586 19.0241 4.66128 17.97 4.66128ZM15.5737 6.57003C15.5737 5.24662 16.6466 4.17378 17.97 4.17378C19.2934 4.17378 20.3662 5.24662 20.3662 6.57003C20.3662 7.89344 19.2934 8.96628 17.97 8.96628C16.6466 8.96628 15.5737 7.89344 15.5737 6.57003Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1634_232">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PickupDelivery;
